import { fetchMediaData, transformMediaItemToMediaData } from "wpp-utilities";
import log from "../../utils/logger/library";
import {
    isMpxId,
    isSourceId,
} from "../../utils/dataTransform/ContentItem/library";
import * as config from "config-api";

const fetchEnv = config.getString("Client.wppUtilities.environment");

export const getPlayableMediaData = async (mediaItem, shouldFetch) => {
    let mediaData = {};

    const { sourceId } = mediaItem;

    try {
        // use new GQL ContentItem query from wpp-utilities
        if (isSourceId(sourceId) || isMpxId(sourceId)) {
            mediaData = shouldFetch
                ? await fetchMediaData(sourceId, fetchEnv)
                : transformMediaItemToMediaData(mediaItem);
        } else {
            log.warn(`(getPlayableMediaData) Unknown sourceId ${sourceId}`);
        }
    } catch (error) {
        log.error("(getPlayableMediaData) Error fetching mediaData", error);
    }

    return mediaData;
};
